module.exports = __webpack_public_path__ + "media/images/products/products/b1-0813f002fe2e555c667a6fe53b11e871.jpg";